/**
 * CampInfo 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileInfo } from './file_info'

/**
 * CampInfo
 */
export interface CampInfo {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 主键（UUID4），全局唯一，不可重复，36位 */
  id?: string
  /** 删除时间（UTC），goframe会自动处理deleted_at，如果想避免goframe自动处理，请使用Unscoped() */
  deleted_at?: string
  /** 删除原因 */
  deleted_reason?: string
  /** 禁用状态 */
  disabled?: boolean
  /** 禁用时间 */
  disabled_at?: string
  /** 禁用截止时间（null表示永久禁用） */
  disabled_until?: string
  /** 禁用原因 */
  disabled_reason?: string
  /** 创建管理员ID */
  creator_staff_id?: string
  /** 创建用户ID */
  creator_id?: string
  /** 大本营名称 */
  name?: string
  /** 大本营简介 */
  bio?: string
  /** 头像文件ID */
  avatar_id?: string
  /** 头像文件信息 */
  avatar?: FileInfo
  /** 群组段位层次（可选值：0=未知; 1=青铜; 2=白银; 3=黄金; 4=铂金; 5=钻石; 6=星耀; 7=最强王者） */
  rank_tier?: number
  /** 大本营加入策略（可选值：open=自由加入; approval=需要申请加入; answer=需要回答问题） */
  join_policy?: string
  /** 加入审核问题 */
  join_question?: string
}

/**
 * CampInfo Schema
 */
export const CampInfoSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    id: {
      description: '主键（UUID4），全局唯一，不可重复，36位',
      format: 'string',
      type: 'string',
      label: '主键',
    },
    deleted_at: {
      description:
        '删除时间（UTC），goframe会自动处理deleted_at，如果想避免goframe自动处理，请使用Unscoped()',
      format: '*time.Time',
      type: 'string',
      label: '删除时间',
    },
    deleted_reason: {
      description: '删除原因',
      format: 'string',
      type: 'string',
      label: '删除原因',
    },
    disabled: {
      description: '禁用状态',
      format: 'bool',
      type: 'boolean',
      label: '禁用状态',
    },
    disabled_at: {
      description: '禁用时间',
      format: '*time.Time',
      type: 'string',
      label: '禁用时间',
    },
    disabled_until: {
      description: '禁用截止时间（null表示永久禁用）',
      format: '*time.Time',
      type: 'string',
      label: '禁用截止时间',
    },
    disabled_reason: {
      description: '禁用原因',
      format: 'string',
      type: 'string',
      label: '禁用原因',
    },
    creator_staff_id: {
      description: '创建管理员ID',
      format: 'string',
      type: 'string',
      label: '创建管理员ID',
    },
    creator_id: {
      description: '创建用户ID',
      format: 'string',
      type: 'string',
      label: '创建用户ID',
    },
    name: {
      description: '大本营名称',
      format: 'string',
      type: 'string',
      label: '大本营名称',
    },
    bio: {
      description: '大本营简介',
      format: 'string',
      type: 'string',
      label: '大本营简介',
    },
    avatar_id: {
      description: '头像文件ID',
      format: 'string',
      type: 'string',
      label: '头像文件ID',
    },
    avatar: {
      $ref: 'FileInfo',
      description: '头像文件信息',
      label: '头像文件信息',
    },
    rank_tier: {
      description:
        '群组段位层次（可选值：0=未知; 1=青铜; 2=白银; 3=黄金; 4=铂金; 5=钻石; 6=星耀; 7=最强王者）',
      format: 'cons.GroupRankTier',
      type: 'integer',
      label: '群组段位层次',
    },
    join_policy: {
      description:
        '大本营加入策略（可选值：open=自由加入; approval=需要申请加入; answer=需要回答问题）',
      format: 'cons.CampJoinPolicy',
      type: 'string',
      label: '大本营加入策略',
    },
    join_question: {
      description: '加入审核问题',
      format: 'string',
      type: 'string',
      label: '加入审核问题',
    },
  },
  type: 'object',
}
